import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: '',
    viewedUser: {},
    viewedAlert: {},
    viewedNotification: {},
    success: false,
    error: false,
    message: '',
  },
  getters: {
  },
  mutations: {
    setUser(state, payload) {
      this.state.email = payload.email;
    },
    setViewedUser(state, payload) {
      this.state.viewedUser = payload;
    },
    setViewedAlert(state, payload) {
      this.state.viewedAlert = payload;
    },
    setViewedNotification(state, payload) {
      this.state.viewedNotification = payload;
    },
    displayResponse(state, payload) {
      this.state.message = payload.message;

      if (payload.type == "success") {
        this.state.success = true;
        let that = this;

        setTimeout(function () {
          that.state.success = false;
        }, 3000);
      } else {
        this.state.error = true;
        let that = this;

        setTimeout(function () {
          that.state.error = false;
        }, 3000);
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
